import { render, staticRenderFns } from "./EntitySearch.vue?vue&type=template&id=28c87e93&scoped=true&"
import script from "./EntitySearch.vue?vue&type=script&lang=ts&"
export * from "./EntitySearch.vue?vue&type=script&lang=ts&"
import style0 from "./EntitySearch.vue?vue&type=style&index=0&id=28c87e93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c87e93",
  null
  
)

export default component.exports